import { Messages } from "@arcware-cloud/shared-pixelstreaming-websdk";
import { AggregatedStats, CandidatePairStats } from "@epicgames-ps/lib-pixelstreamingfrontend-ue5.5";

export function Stats(stats: AggregatedStats) {
  const result = Messages.ZStats.shape.stats.parse({
    /**
     * Other known properties.
     */
    codecs: stats.codecs,
    candidatePair: stats.candidatePairs,
    localCandidates: stats.localCandidates,
    remoteCandidates: stats.remoteCandidates,
    DataChannelStats: stats.datachannelStats,

    // Received (last) for ticket
    bytesReceived: forceNumber(stats.inboundVideoStats.bytesReceived),
    // Packets Lost (last) for ticket
    packetsLost: forceNumber(stats.inboundVideoStats.packetsLost),
    // Video resolution: highest lowest average (portrait) and highest lowest average (landscape) for ticket
    frameWidth: forceNumber(stats.inboundVideoStats.frameWidth!),
    // Video resolution: highest lowest average (portrait) and highest lowest average (landscape) for ticket
    frameHeight: forceNumber(stats.inboundVideoStats.frameHeight!),
    // Frames decoded (Last) for ticket
    framesDecoded: forceNumber(stats.inboundVideoStats.framesDecoded!),
    // Framerate (low / high, avg) for ticket
    framesPerSecond: forceNumber(stats.inboundVideoStats.framesPerSecond!),
    // frames dropped (last) for ticket
    framesDropped: forceNumber(stats.inboundVideoStats.framesDropped!),
    // Videocodec (once) for ticket
    videoCodec: stats.inboundVideoStats.codecId,
    // audiocodec (once) for ticket
    audioCodec: stats.inboundAudioStats.codecId,
    // browser type and version for ticket (arcware / addition)
    browserInfo: {
      // to be received!
      userAgent: navigator.userAgent,
      platform: (navigator as any).oscpu || navigator.platform || null, // navigator.oscpu,
      language: navigator.language,
    },
    // Net RTT (low, high, avg)
    // BEGIN TW CHANGE
    currentRTT: calcRTT(stats.candidatePairs),
    // END TW CHANGE
    // Duration (last)
    sessionRunTime: stats.sessionStats.runTime,
    // Controls stream input (??)
    controlsStreamInput: stats.sessionStats.controlsStreamInput,
    // video quantization parameter (low / high / avg if applicable)
    videoEncoderAvgQP: forceNumber(stats.sessionStats.videoEncoderAvgQP),
    // Video bitrate (min / max / avg)
    videoBitrate: forceNumber(stats.inboundVideoStats.bitrate!),
    // Audio bitrate (min / max / avg)
    audioBitrate: forceNumber(stats.inboundAudioStats.bitrate!),
  });

  return result;
}

/**
 * Given an array of candidate pairs this function will find the highest RTT for the selected pair
 * @param pairs - An array of candidate pairs
 * @returns The highest round trip time of a selected candidate pair
 */
function calcRTT(pairs: CandidatePairStats[]): Number {

  let rtt = 0;
  pairs.forEach((pair: CandidatePairStats) => {

    if (pair.selected && pair.currentRoundTripTime > rtt) {
      rtt = pair.currentRoundTripTime;
    }
  })

  return rtt;
}

/**
 * Takes a number and forces it to return a number. If the value passed in is NaN, 0 will be returned.
 * @param value - A number
 * @returns The number passed in as value or 0 if vlaue was NaN
 */
function forceNumber(value: number): Number {
  return isNaN(value) ? 0 : value;
}
